import { Card, Col, Row, Space, Button, Spin, Select, Tag, DatePicker, Modal, Checkbox, Table, Skeleton, Tooltip } from "antd";
import "../assets/css/evidence.css";
import React from "react";
import { StoreContext } from "../store/RootStore";
import dayjs from "dayjs";
import EvidenceStore from "../store/Evidence";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import carEvidence from '../assets/images/carEvidence.png';
import driverEvidence from '../assets/images/driverEvidence.png';
import dangerEvidence from '../assets/images/dangerEvidence.png';
import VehicleStore from "../store/VehicleStore";


const { RangePicker } = DatePicker;
class Evidence extends React.Component {
    constructor(props, context) {
        super(props);
        this.onRangeChange = this.onRangeChange.bind(this);
        this.evidenceStore = context.evidenceStore;
        this.vehicleStore = new VehicleStore(this);

        this.state = {
            loading: false,
            fromDate: null,
            toDate: null,
            vehicleId: [],
            companyId: null,
            alarmId: [],
            driverId: [],
            showVehicleList: false,
            showDriverList: false,
            showAlarmList: false,
            vehicles: [],
            selectedVehicleKeys: [],
            selectedVehicles: [],
            vehicleColumns: [
                {
                    title: context.translate("_VEHICLE_ID_"),
                    dataIndex: "vehicleId",
                },
                {
                    title: context.translate("_VEHICLE_NO_"),
                    dataIndex: "vehicleNo",
                    // width:"10%",
                }
            ],
            drivers: [],
            selectedDriverKeys: [],
            selectedDrivers: [],
            driverColumns: [
                {
                    title: context.translate("_DRIVER_ID_"),
                    dataIndex: "driverId",
                },
                {
                    title: context.translate("_NAME_"),
                    dataIndex: "name",
                },

            ],
            alarms: [],
            selectedAlarmKeys: [],
            selectedAlarms: [],
            alarmColumns: [
                {
                    title: context.translate("_ALARM_NAME_"),
                    dataIndex: "alarmName",
                },
                {
                    title: context.translate("_ALARM_ID_"),
                    dataIndex: "alarmId",
                }
            ],
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            sortBy: "date",
            loadedIframes: {},
            visibleFrames: {},
            page: 0,
            update: 0,
            currentPage: 0,
            visibleEvidence: [],
            itemsPerLoad: 2,
            hasMore: true,
            loadedFrames: {},

        }
        this.iframeRefs = {};
        this.observer = null;
        this.rangePresets = {
            items: [
                {
                    label: "Today",
                    value: [dayjs(), dayjs().endOf("day")],
                    key: 1,
                },
                {
                    key: "yesterday",
                    label: "Yesterday",
                    value: [
                        dayjs().subtract(1, "day").startOf("day"),
                        dayjs().subtract(1, "day").endOf("day"),
                    ],
                },
                {
                    key: "Last 7 Days",
                    label: "Last 7 Days",
                    value: [dayjs().add(-6, "d"), dayjs()],
                },

                {
                    label: "Last 30 Days",
                    value: [dayjs().add(-29, "d"), dayjs()],
                    key: 4,
                },
                {
                    label: "This Month",
                    value: [dayjs().startOf("month"), dayjs().endOf("month")],
                    key: 5,
                },
                {
                    label: "Last Month",
                    value: [
                        dayjs().subtract(1, "month").startOf("month"),
                        dayjs().subtract(1, "month").endOf("month"),
                    ],
                    key: 6,
                },
            ],
        };
    }

    componentWillUnmount() {
        if (this.observer) this.observer.disconnect();
    }
    onRangeChange = async (dates, dateStrings) => {
        const startDate = new Date(dates[1]);
        const endDate = new Date(dates[0]);
        const diffrence = Math.round((startDate - endDate) / (1000 * 60 * 60 * 24));

        if (diffrence === 0 || diffrence === 1) {
            this.setState({ showFullSummary: false });
        } else {
            this.setState({ showFullSummary: true });
        }

        if (dates) {
            await this.setState({
                fromDate: dayjs(dateStrings[0]).format("YYYY-MM-DD 00:00:00"),
                toDate: dayjs(dateStrings[1]).format("YYYY-MM-DD 23:59:59"),
            });

            await this.getEvidenceData();
            await this.setState({ update: 1 });
        }
    };
    async componentDidMount() {
        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;
            await this.setState({ companyId: companyId });
        }
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const key = entry.target.dataset.key;
                        this.setState(prev => ({
                            visibleFrames: { ...prev.visibleFrames, [key]: true }
                        }));
                        this.observer.unobserve(entry.target); // stop observing once visible
                    }
                });
            },

            { threshold: 0.1 }
        );

        await this.getEvidenceData();
    }
    getEvidenceData = async (page = 0) => {
        console.log(this.state.alarmId)
        const data = {
            companyId: this.state.companyId,//1526,
            alarmId: this.state.alarmId,
            vehicleId: this.state.vehicleId,
            driverId: this.state.selectedDrivers,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            sortBy: this.state.sortBy
        };

        await this.evidenceStore.getEvidence(data, page);

        const evidence = this.evidenceStore.evidence; // full data from API
        if (evidence && evidence.length > 0) {
            this.setState({
                page: 1,
                update: 1,
                visibleEvidence: evidence.slice(0, this.state.itemsPerLoad), // show first few groups
                hasMore: evidence.length > this.state.itemsPerLoad
            });
        } else {
            this.setState({
                visibleEvidence: [],
                hasMore: false
            });
        }
    };

    handleSearchChange = (e) => {

        const searchText = e.target.value.toLowerCase();
        this.setState({ searchText });

        const evidence = this.evidenceStore.evidence || [];

        // Filter at group + record level
        const filteredGroups = evidence.map(group => {
            const filteredRecords = group.records.filter(item => {
                return (
                    (item.driverName && item.driverName.toLowerCase().includes(searchText)) ||
                    (item.vehicleNo && item.vehicleNo.toLowerCase().includes(searchText)) ||
                    // (item.location && item.location.toLowerCase().includes(searchText))
                    (item.alarmName && item.alarmName.toLowerCase().includes(searchText))
                );
            });

            return { ...group, records: filteredRecords };
        }).filter(group => group.records.length > 0); // remove empty groups

        this.setState({ visibleEvidence: searchText ? filteredGroups : evidence });
    };
    handleCardClick = (item) => {
        //console.log(item.channel, "channel");
        console.log(item,);
        const domain = window.location.origin;
        console.log(window.location);
        // const url = `/EvidenceDetails?id=${encodeURIComponent(item.id)}&session=${encodeURIComponent(item.sessionNo)}&value=${encodeURIComponent(item.value)}&fromDate=${encodeURIComponent(this.state.fromDate)}&toDate=${encodeURIComponent(this.state.toDate)}`;
        // window.open(url, "_blank", "noopener,noreferrer");
        // const url = `https://sa.trackeazy.com/EvidenceDetails?id=${encodeURIComponent(item.id)}&fromDate=${encodeURIComponent(this.state.fromDate)}&toDate=${encodeURIComponent(this.state.toDate)}&filename=${encodeURIComponent(item.vdofilename)}&bsjid=${encodeURIComponent(item.bsjId)}`;
        const url = domain + `/EvidenceDetails?id=${encodeURIComponent(item.id)}&fromDate=${encodeURIComponent(this.state.fromDate)}&toDate=${encodeURIComponent(this.state.toDate)}&vdofilename=${encodeURIComponent(item.vdofilename)}&bsjid=${encodeURIComponent(item.bsjId)}&deviceId=${encodeURIComponent(item.deviceId)}`;
        window.open(url, "_blank");
    };
    // handleCardClick = (item) => {
    //     console.log(item.channel, "channel");
    //     console.log(item.id, "id");
    //     const url = `/EvidenceDetails?id=${encodeURIComponent(item.id)}&session=${encodeURIComponent(item.sessionNo)}&value=${encodeURIComponent(item.value)}&fromDate=${encodeURIComponent(this.state.fromDate)}&toDate=${encodeURIComponent(this.state.toDate)}`;
    //     window.open(url, "_blank", "noopener,noreferrer");
    // };

    // renderEvidence(group) {
    //     const dateLabel = new Date(group.alarmDate).toLocaleDateString("en-US", {
    //         day: "numeric", month: "long", year: "numeric"
    //     });

    //     return (
    //         <div key={group.alarmDate} style={{ marginBottom: "24px" }}>
    //             <p style={{ marginBottom: 16, fontSize: "25px", fontWeight: 500 }}>
    //                 {dateLabel}
    //             </p>
    //             <Row gutter={[16, 16]} className="evidence-grid">
    //                 {group.records.map((item) => {
    //                     if (!item?.id || !item?.channel) {
    //                         console.warn("Skipping invalid record", item);
    //                         return null;
    //                     }

    //                     const frameKey = `${item.id}-${item.channel}`;
    //                     const isLoaded = this.state.loadedFrames?.[frameKey] || false;

    //                     return (
    //                         <Col className="five-col" key={frameKey}>
    //                             <Card
    //                                 className="evidence-card"
    //                                 hoverable
    //                                 onClick={() => this.handleCardClick(item)}
    //                                 style={{
    //                                     width: "100%",
    //                                     height: "100%",
    //                                     display: "flex",
    //                                     flexDirection: "column",
    //                                     border: "1px solid #D4D4D5",
    //                                     borderRadius: "4px",
    //                                     background: "#fff",
    //                                     boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
    //                                     overflow: "hidden",
    //                                     cursor: "pointer"
    //                                 }}
    //                                 bodyStyle={{
    //                                     padding: 10,
    //                                     display: "flex",
    //                                     flexDirection: "column",
    //                                     flexGrow: 1
    //                                 }}
    //                             >
    //                                 <div
    //                                     style={{
    //                                         position: "relative",
    //                                         height: 180,
    //                                         background: "#000"
    //                                     }}
    //                                 >
    //                                     <img
    //                                         src={item.thumbnailUrl || "/fallback.jpg"}
    //                                         alt="preview"
    //                                         style={{
    //                                             position: "absolute",
    //                                             top: 0,
    //                                             left: 0,
    //                                             width: "100%",
    //                                             height: "100%",
    //                                             objectFit: "cover",
    //                                             zIndex: 0
    //                                         }}
    //                                     />
    //                                     <iframe
    //                                         src={`https://media.trackeazy.com/howendownloaded/test/multimedia#${item.sessionNo}-${item.value}`}
    //                                         width="100%"
    //                                         height="100%"
    //                                         frameBorder="0"
    //                                         style={{
    //                                             position: "absolute",
    //                                             top: 0,
    //                                             left: 0,
    //                                             width: "100%",
    //                                             height: "100%",
    //                                             border: "1px solid #ccc",
    //                                             background: "transparent",
    //                                             zIndex: 1
    //                                         }}
    //                                     />
    //                                 </div>

    //                                 <div
    //                                     style={{
    //                                         display: "flex",
    //                                         flexDirection: "column",
    //                                         gap: 4,
    //                                         marginLeft: 10
    //                                     }}
    //                                 >
    //                                     <div
    //                                         style={{
    //                                             fontSize: "14px",
    //                                             fontWeight: 600,
    //                                             color: "#000"
    //                                         }}
    //                                     >
    //                                         Vision: {item.alarmName}
    //                                     </div>
    //                                     <div style={{ fontSize: "13px", color: "#555" }}>
    //                                         {item.startTime} (AST)
    //                                     </div>
    //                                     <div style={{ fontSize: "13px", color: "#444" }}>
    //                                         {item.model
    //                                             ? `${item.model} - (${item.vehicleNo})`
    //                                             : `(${item.vehicleNo})`}
    //                                     </div>
    //                                     <div style={{ fontSize: "13px", color: "#444" }}>
    //                                         {item.location ? item.location : "-"}
    //                                     </div>
    //                                 </div>
    //                             </Card>
    //                         </Col>
    //                     );
    //                 })}
    //             </Row>
    //         </div>
    //     );
    // }

    renderEvidence(group) {
        const dateLabel = new Date(group.alarmDate).toLocaleDateString("en-US", {
            day: "numeric", month: "long", year: "numeric"
        });

        return (
            <div key={group.alarmDate} style={{ marginBottom: "24px" }}>
                <p style={{ marginBottom: 16, fontSize: "25px", fontWeight: 500 }}>
                    {dateLabel}
                </p>
                <Row gutter={[16, 16]} className="evidence-grid">
                    {group.records.map((item) => {
                        // if (!item?.id || !item?.channel) {
                        if (!item?.id) {
                            console.warn("Skipping invalid record", item);
                            return null;
                        }
                        const scale = 0.5;//this.getScale(item);
                        // const frameKey = `${item.id}-${item.channel}`;
                        const frameKey = `${item.bsjId}`;
                        const isLoaded = this.state.loadedFrames?.[frameKey] || false;

                        return (
                            <Col className="five-col" key={frameKey}>
                                <Card
                                    className="evidence-card"
                                    hoverable
                                    onClick={() => this.handleCardClick(item)}
                                    style={{
                                        width: "100%",
                                        minHeight: 400,// height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        border: "1px solid #D4D4D5",
                                        borderRadius: "4px",
                                        background: "#fff",
                                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                                        overflow: "hidden",
                                        cursor: "pointer"
                                    }}
                                    bodyStyle={{
                                        padding: 10,
                                        display: "flex",
                                        flexDirection: "column",
                                        flexGrow: 1
                                    }}
                                >


                                    {/* <div
                                        style={{
                                            position: "relative",
                                            height: 290,
                                            background: "#000",
                                            overflow: "hidden",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <iframe
                                            src={item.filename}
                                            frameBorder="0"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                width: "90%",
                                                height: "110%",
                                                transform: "translate(-50%, -50%) scale(1.0)", // 👈 gentle zoom-out
                                                border: "none"
                                            }}
                                        />
                                    </div> */}
                                    <div
                                        style={{
                                            height: 290,
                                            background: "#000",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <img
                                            src={item.filename}
                                            alt=""
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain"
                                            }}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 4,
                                            marginLeft: 10
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#000"
                                            }}
                                        >
                                            Vision: {item.alarmName}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#555" }}>
                                            {item.startTime}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#444" }}>
                                            {item.model
                                                ? `${item.model} - (${item.vehicleNo})`
                                                : `(${item.vehicleNo})`}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#444" }}>
                                            {item.location ? item.location : "-"}
                                        </div>
                                    </div>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        );
    }

    vehicleFilter = async () => {
        this.setState({ showVehicleList: true, loading: true });
        const companyId = this.state.companyId;
        const data = await this.evidenceStore.getVehiclesCompanyId(companyId);
        this.setState({
            vehicles: data || [],
            loading: false
        });
    };
    driverFilter = async () => {
        this.setState({ showDriverList: true, loading: true });

        const data = await this.evidenceStore.getDriversByCompanyId({
            companyId: this.state.companyId
        });
        this.setState({
            drivers: data || [],
            loading: false
        });

    }
    alarmFilter = async () => {
        this.setState({ showAlarmList: true })
        const data = await this.evidenceStore.getAlarms();
        this.setState({
            alarms: data || [],
            loading: false
        });

    }
    onSelectChange = (selectedRowKeys) => {
        this.setState({
            selectedVehicleKeys: selectedRowKeys, // controls checkboxes
            selectedVehicles: selectedRowKeys     // keep IDs for API
        });
    };

    onSelectChangeDriver = (selectedRowKeys, selectedRows) => {

        const driverIds = selectedRows.map(row => row.driverId);
        this.setState({
            selectedDriverKeys: driverIds,
            selectedDrivers: driverIds
        });
    };

    onSelectChangeAlarm = (selectedRowKeys) => {
        this.setState({
            selectedAlarmKeys: selectedRowKeys, // keeps checkboxes controlled
            selectedAlarms: selectedRowKeys     // same IDs for API
        });
    };
    render() {
        const { showVehicleList, showDriverList, showAlarmList, loading } = this.state;
        const rowSelection = {
            selectedRowKeys: this.state.selectedVehicleKeys,
            onChange: this.onSelectChange
        };
        const rowSelectionDriver = {
            selectedRowKeys: this.state.selectedDriverKeys,
            onChange: this.onSelectChangeDriver
        };
        const rowSelectionAlarm = {
            selectedRowKeys: this.state.selectedAlarmKeys,
            onChange: this.onSelectChangeAlarm
        };
        const { group, dateLabel } = this.props;
        return <>
            <div className="evidence-header" >
                <Row className="headerFixed" style={{ height: "50px" }}>
                    <Col span={12}>
                        <div className="heading">
                            {this.context.translate("_EVIDENCE_")}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="evidence-container">
                <div className="filter-toolbar-container">
                    <div className="filter-bar">
                        <div className="date-range">
                            <label>{this.context.translate('_DATE_RANGE_')}</label>
                            <RangePicker
                                allowClear={false}
                                format="YYYY-MM-DD"
                                size="small"
                                showTime={false}
                                presets={this.rangePresets.items}
                                onChange={this.onRangeChange}
                                style={{ width: "100%" }}
                                defaultValue={[dayjs().startOf("day"), dayjs()]}
                            // defaultValue={[this.state.fromDate,]}
                            />
                        </div>
                        <div className="filters">
                            <label>{this.context.translate('_FILTER_BY_')}:</label>
                            <div className="filter-buttons">
                                <Tooltip title={this.context.translate('_VEHICLES_')}><Button className="filter-btn active" icon={<img src={carEvidence} alt="Car" style={{ width: "15px" }} />} onClick={this.vehicleFilter}></Button></Tooltip>
                                <Tooltip title={this.context.translate('_DRIVER_')}> <Button className="filter-btn active" icon={<img src={driverEvidence} alt="driver" style={{ width: "16px" }} />} onClick={this.driverFilter}></Button></Tooltip>
                                <Tooltip title={this.context.translate('_ALARM_')}> <Button className=" filter-btn active" icon={<img src={dangerEvidence} alt="alert" style={{ width: "16px" }} />} onClick={this.alarmFilter}></Button></Tooltip>
                            </div>
                        </div>
                        <div className="search-section">
                            <input
                                type="text"
                                placeholder={this.context.translate('_SEARCH_')}
                                value={this.state.searchText}
                                onChange={this.handleSearchChange}
                            />
                        </div>

                    </div>
                </div>
                <div className="sort-bar">
                    <label>{this.context.translate('_SORT_BY_')}</label>
                    <Select
                        defaultValue="date"
                        style={{ width: 150 }}
                        // onChange={(value) => this.sortBy(value)}
                        options={[
                            { value: 'date', label: 'Date' },
                            { value: 'driver', label: 'Driver' }
                        ]}
                    />
                    {/* <button className="sort-btn" onClick={this.sortBy("date")}>All</button> */}
                </div>
            </div>
            <div className="evidence-container-grid">
                <div className="evidence-list" onScroll={this.handleScroll}>
                    {this.state.visibleEvidence && this.state.visibleEvidence.length > 0
                        ? this.state.visibleEvidence.map(group => this.renderEvidence(group))
                        : (
                            <Col span={24} style={{ textAlign: "center", padding: "50px 0", color: "#999" }}>
                                {this.context.translate('_NO_DATA_AVAILABLE_')}
                            </Col>
                        )}
                </div>
            </div>

            <Modal
                title={this.context.translate("_VEHICLE_LIST_")}
                open={showVehicleList}
                onCancel={() => this.setState({ showVehicleList: false })}
                centered
                width={1000}
                style={{ height: "500px" }}
                footer={[
                    <Button key="cancel" onClick={() => this.setState({ showVehicleList: false })}>
                        {this.context.translate('_CANCEL_')}
                    </Button>,
                    <Button
                        key="select"
                        type="primary"
                        onClick={() => {
                            const vehicleIds = this.state.selectedVehicles.join(","); // "10,12,15"
                            this.setState({
                                vehicleId: vehicleIds,
                                showVehicleList: false
                            }, () => {
                                this.getEvidenceData(); // call after state update
                            });

                            console.log("Selected Vehicle IDs:", vehicleIds);
                        }}
                    >
                        {this.context.translate('_SELECT_')}                          </Button>
                ]}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {loading ? (
                        <Spin />
                    ) : (
                        <div style={{ height: "450px", marginTop: "10px" }}>
                            <Table
                                bordered
                                rowSelection={rowSelection}
                                columns={this.state.vehicleColumns}
                                dataSource={this.state.vehicles}
                                pagination={false}
                                scroll={{ y: 360 }}
                                rowKey="vehicleId"
                            />
                        </div>

                    )}
                </div>
            </Modal>
            <Modal
                title={this.context.translate('_FLEET_DRIVER_DRIVERLIST_TITLE_')}
                open={showDriverList}
                onCancel={() => this.setState({ showDriverList: false })}
                centered
                width={1000}
                style={{ height: "500px" }}
                footer={[
                    <Button key="cancel" onClick={() => this.setState({ showDriverList: false })}>
                        {this.context.translate('_CANCEL_')}
                    </Button>,
                    <Button
                        key="select"
                        type="primary"
                        onClick={() => {
                            // Store selected IDs in vehicleId state
                            this.setState({
                                driverId: this.state.selectedDriverKeys,
                                showDriverList: false
                            });
                            this.getEvidenceData();
                            console.log("Selected Vehicle IDs:", this.state.selectedDriverKeys);
                        }}
                    >
                        {this.context.translate('_SELECT_')}
                    </Button>
                ]}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {loading ? (
                        <Spin />
                    ) : (
                        <div style={{ height: "450px", marginTop: "10px" }}>
                            <Table
                                bordered
                                rowSelection={rowSelectionDriver}
                                columns={this.state.driverColumns}
                                dataSource={this.state.drivers}
                                pagination={false}
                                scroll={{ y: 360 }}
                                rowKey="driverId"
                            />
                        </div>

                    )}
                </div>
            </Modal>
            <Modal
                title={this.context.translate('_ALARM_LIST_')}
                open={showAlarmList}
                onCancel={() => this.setState({ showAlarmList: false })}
                centered
                width={1000}
                style={{ height: "500px" }}
                footer={[
                    <Button key="cancel" onClick={() => this.setState({ showAlarmList: false })}>
                        {this.context.translate('_CANCEL_')}
                    </Button>,
                    <Button
                        key="select"
                        type="primary"
                        onClick={() => {
                            const alarmIds = this.state.selectedAlarms.join(","); // "1,2,3"
                            this.setState({
                                alarmId: alarmIds,
                                showAlarmList: false
                            }, () => {
                                this.getEvidenceData(); // call after state update
                            });

                            console.log("Selected Alarm IDs:", alarmIds);
                        }}
                    >
                        {this.context.translate('_SELECT_')}                    </Button>
                ]}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {loading ? (
                        <Spin />
                    ) : (
                        <div style={{ height: "450px", marginTop: "10px" }}>
                            <Table
                                bordered
                                rowSelection={rowSelectionAlarm}
                                columns={this.state.alarmColumns}
                                dataSource={this.state.alarms}
                                pagination={false}
                                scroll={{ y: 360 }}
                                rowKey="alarmId"
                            />
                        </div>

                    )}
                </div>
            </Modal>

        </>;
    }
}
Evidence.contextType = StoreContext;
export default observer(withRouter(Evidence));